import React from "react";
import { addDays } from "../lib/format";
import { Chip, Input } from "../ui";

export const NEXT_STEP_PRESETS = [
    { label: "Tomorrow", days: 1 },
    { label: "+3 days", days: 3 },
    { label: "+1 week", days: 7 },
    { label: "+2 weeks", days: 14 },
];

// Next step + date, both required on an open lead (API 422
// next_step_required). invalid marks both inputs.
export default function NextStepFields({ step, date, onStep, onDate, invalid, from, autoFocus, label = "Next step" }) {
    return (
        <div>
            <span className="hz-label">
                {label}
                <span className="req"> *</span>
            </span>
            <div className="hz-form-2" style={{ gridTemplateColumns: "1fr 160px" }}>
                <Input value={step} onChange={onStep} placeholder="What happens next" className={invalid && !String(step || "").trim() ? "hz-invalid" : ""} autoFocus={autoFocus} aria-label="Next step" />
                <Input type="date" value={date || ""} onChange={onDate} className={invalid && !date ? "hz-invalid" : ""} aria-label="Next step date" />
            </div>
            <div className="hz-row-wrap" style={{ gap: 6, marginTop: 6 }}>
                {NEXT_STEP_PRESETS.map((p) => {
                    const v = addDays(from, p.days);
                    return (
                        <Chip key={p.days} small active={date === v} onClick={() => onDate(v)}>
                            {p.label}
                        </Chip>
                    );
                })}
            </div>
        </div>
    );
}
